// Centralized brand palette and gradients
// Usage: import { brandGradients, brandTextGradients } from '../theme/palette'

export const brandGradients = {
  // Deep navy -> blue panel gradient (Option B)
  panel: 'linear-gradient(135deg, #0f1f3b 0%, #153e74 5%, #256dbe 50%, #4facfe 100%)',
  // Soft panel bg if needed
  panelSoft: 'linear-gradient(135deg, rgba(15,31,59,0.04) 0%, rgba(21,62,116,0.06) 35%, rgba(37,109,190,0.06) 70%, rgba(79,172,254,0.08) 100%)',
};

export const brandTextGradients = {
  // Accent gradient for text (teal -> violet) used in section kicker labels
  accent: 'linear-gradient(90deg, #4facfe 0%, #a445b2 60%, #6a11cb 100%)',
};

export const palette = {
  gradients: brandGradients,
  text: brandTextGradients,
};

export default palette;
